import React from 'react';

import { flagStyles } from '../settings';

const SvgZA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5856px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgZA;
